"use strict";

/*
  https://git.hubteam.com/HubSpot/CRM-Issues/issues/586

  Avoid calling this file directly.
  Instead, use the abstraction `DealPermissions`
*/
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canMoveStage = exports.closedLostStage = void 0;

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _enviro = _interopRequireDefault(require("enviro"));

var _BETDealPermissionsPipelineStages = _interopRequireDefault(require("./BETDealPermissionsPipelineStages"));

var memoizedCanMoveStage = (0, _memoize.default)(function (pipeline, prevStage, nextStage, scopes) {
  var isSalesOpsUser = scopes.has('bet-bypass-deal-stage-restrictions');

  if (isSalesOpsUser) {
    return true;
  }

  var env = _enviro.default.isQa() ? 'QA' : 'PROD';

  var addStages = _BETDealPermissionsPipelineStages.default.getIn([env, pipeline, 'blacklistAddStages']);

  var removeStages = _BETDealPermissionsPipelineStages.default.getIn([env, pipeline, 'blacklistRemoveStages']);

  return !(addStages && addStages.includes(nextStage) || removeStages && removeStages.includes(prevStage));
});

var closedLostStage = function closedLostStage(pipeline) {
  var env = _enviro.default.isQa() ? 'QA' : 'PROD';
  return _BETDealPermissionsPipelineStages.default.getIn([env, pipeline, 'closedLost']);
};

exports.closedLostStage = closedLostStage;

var canMoveStage = function canMoveStage(pipeline, prevStage, nextStage, scopes, includeWarning) {
  if (memoizedCanMoveStage(pipeline, prevStage, nextStage, scopes)) {
    return true;
  }

  if (includeWarning) {
    (0, _Alerts.addWarning)('bet.BETDealPermissions.unauthorizedStageChange');
  }

  return false;
};

exports.canMoveStage = canMoveStage;